<template>
  <div class="renewPrice">
    <div class="renewPrice__header">
      <span class="label">ICCID：</span>
      <el-input v-model="params.iccid" size="small" class="w__160" placeholder="请输入ICCID" />
      <span class="label">SIM卡号：</span>
      <el-input v-model="params.simCard" size="small" class="w__160" placeholder="请输入SIM卡号" />
      <span class="label">操作时间：</span>
      <el-date-picker
        v-model="params.time"
        size="small"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      <el-button
        style="margin-left:10px"
        type="primary"
        size="small"
        @click="getData"
      >查询</el-button>
    </div>
    <div class="renewPrice__content" v-loading="loading">
      <div class="filter-table-wrap">
        <el-table
          :data="tableData"
          stripe
          style="width: 100%"
          size="mini"
          border
          height="calc(100% - 90px)">
          <el-table-column
            type="index"
            width="50"
            label="序号"
          >
          </el-table-column>
          <el-table-column
            prop="sn"
            align="center"
            label="SN"
            width="150"
          />
          <el-table-column
            prop="customCode"
            align="center"
            label="客户代码"
            width="150"
          />
          <el-table-column
            prop="beforeIccid"
            align="center"
            label="修改之前的iccid"
          />
          <el-table-column
            prop="afterIccid"
            align="center"
            label="修改之后iccid"
          />
          <el-table-column
            prop="beforeSimCard"
            align="center"
            label="修改之前的SIM卡号"
          />
          <el-table-column
            prop="afterSimCard"
            align="center"
            label="修改之后的SIM卡号"
          />
          <el-table-column
            prop="createTime"
            align="center"
            label="创建时间"
          />
        </el-table>
        <el-pagination
          :current-page.sync="params.pageNumber"
          :page-sizes="[100, 200, 300, 400]"
          :page-size.sync="params.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      tableData:[],
      total:0,
      loading:false,
      params:{
        time:[
          new Date(
            new Date().getTime() - 60*60*24*30*1000
          ).Format('yyyy-MM-dd'), 
          new Date().Format('yyyy-MM-dd')
        ],
        /** SIM卡号 */
        simCard:'',
        /** ICCID */
        iccid:'',
        pageNumber:1,
        pageSize:100
      },
    }
  },
  created(){
    this.getData();
  },
  methods:{
    useCardSupplier(type){
      return {
        1:'北京移动',
        2:'江门移动',
        3:'重庆卡',
        4:'江西卡',
        5:'深圳卡',
        6:'谷米卡',
        7:'北京移动(新)',
        8:'北京移动(新)',
        9:'北京移动(新)',
        10:'北京移动语音卡',
        11:'深圳移动',
        12:'联通',
        13:'北京移动4G卡',
        14:'惠州联通',
        15:'陕西移动',
        16:'云杉卡',
        17:'齐犇卡',
        18:'北京单4G卡',
      }[type];
    },
    //查询数据
    async getData(){
      this.loading = true;
      let { time, ...params } = this.params;
      const { data, total, code, msg } = await this.$API.pageSnRelationLog({
        startTime:time ? `${time[0]} 00:00:00` : '',
        endTime:time ? `${time[1]} 23:59:59` : '',
        ...params
      });
      this.loading = false;
      this.tableData = data || [];
      this.total = total || 0;
      this.$message({
        type:code === 0 ? 'success' : 'warning',
        message:code === 0 ? '搜索成功' : msg
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.renewPrice{
  width: 100%;
  height:100%;
  padding: 10px 0;
  box-sizing: border-box;
  &__header {
    width: 100%;
    display: flex;
    padding: 10px 20px;
    background: #ffffff;
    height: 84px;
    align-items: center;
    font-size: 14px;
    box-sizing: border-box;
    .label{
      display: inline-block;
      margin-left: 10px;
    }
    .w__160{
      width: 160px;
    }
    .w__120{
      width: 120px;
    }
    .filter-type-input {
      background: #edf2f8;
      color: #828588;
      border: none;
      outline: 0;
      padding: 0 15px;
      height: 30px;
    }
    /deep/ .el-date-editor {
      width: 15%;
      .el-input__inner {
        padding-left: 30px;
        height: 30px;
        border-radius: 0;
        outline: none;
        border: 0;
        background: #f3f7fb;
      }
      .el-input__icon {
        line-height: 30px;
      }
    }
  }
  &__content {
    flex: 1;
    background: #fff;
    height: calc(100% - 84px);
    padding-top: 10px;
    padding:0 10px;
    .btn_cursor{
      color:#409EFF;
      display: inline-block;
      padding: 0 10px;
      cursor: pointer;
    }
    .filter-table-wrap {
      border: 1px solid #ebf0f6;
      height: 100%;
      /deep/ .el-pagination {
        padding: 20px;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-end;
        & > span {
          margin: 0;
        }
        .el-pagination__total {
          margin-right: auto;
        }
      }
    }
  }
}
</style>